import type { JsonApiIdentifierDto } from "@dc/gateway-jsonapi";

/**
 * Get the scope id from a JsonApiIdentifierDto or an array of JsonApiIdentifierDto
 * @param scopeId - The scope id
 * @returns The scope id
 */

export const getRelationshipScopeId = (scopeId?: JsonApiIdentifierDto | JsonApiIdentifierDto[] | null): string =>
  Array.isArray(scopeId) ? scopeId?.[0]?.id : (scopeId?.id ?? "");
